import * as React from 'react';
import Helmet from 'react-helmet';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { useLazyGetEventsByTypeQuery } from '../../core/api/eventsSlice';
import { EventsGrid } from '../../components/eventsV2/eventsGrid';
import { EventType } from '../../core/models/events';
import { useUtils } from '../../services/useUtils';

const useStyles = makeStyles()(() => ({
  content: {
    marginTop: '120px',
    padding: '0 16px 60px 16px',
    width: '100%',
  },
  title: {
    fontSize: 28,
    lineHeight: '32px',
    margin: 0,
    marginBottom: 8,
  },
}));

const PAGE_SIZE = 12;

export const PopularEvents = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { toPageTitle } = useUtils();
  const [getEventsByType] = useLazyGetEventsByTypeQuery();

  const loadEvents = async (skip = 0) => {
    const { data } = await getEventsByType({ eventType: EventType.Popular, skip, count: PAGE_SIZE });
    return data ?? [];
  };

  return (
    <Grid container direction="row" justifyContent="center" className={classes.content}>
      <Helmet>
        <title>{toPageTitle(t('Dashboard.PopularEvents'))}</title>
      </Helmet>

      <Grid item xs={12}>
        <Typography variant="h4" component="h1" className={classes.title}>
          {t('Dashboard.PopularEvents')}
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <EventsGrid load={loadEvents} pageSize={PAGE_SIZE} itemXs={4} compact />
      </Grid>
    </Grid>
  );
};
